import get from 'lodash.get';
import { gql } from '@apollo/client';
import { MES_VERSION } from '../../../constants/shared/ApiConstants';
import getApplicationConfigQuery from '../../applicationConfig/shared/applicationConfigQuery';
import getApplicationConfigMutation from '../../applicationConfig/shared/applicationConfigMutation';
import ApolloClient, { errorHandler } from './ApolloClient';

export class ApplicationConfigClient {
    version = MES_VERSION;

    getClient() {
        if (!this.client) {
            this.client = ApolloClient;
        }
        return this.client;
    }

    getApplicationConfig = () => {
        return this.getClient()
            .query({
                query: gql`
                    ${getApplicationConfigQuery(this.version, this.getApplicationConfigParams())}
                `,
            })
            .then(result => get(result, `data.getApplicationConfig_${this.version}`, []))
            .catch(errorHandler);
    };

    uploadAppicationConfig = (updatedPdfAvailability, pdfAvailabilityBK) => {
        return this.getClient()
            .mutate({
                mutation: gql`
                    ${getApplicationConfigMutation(
                        this.version,
                        this.getApplicationConfigMutationParams({
                            updatedPdfAvailability,
                            pdfAvailabilityBK,
                        }),
                    )}
                `,
            })
            .then(result => get(result, `data.postApplicationConfig_${this.version}`, []))
            .catch(errorHandler);
    };
}

export default new ApplicationConfigClient();
